import { Phone, MessageCircle, FileText } from "lucide-react";
import { useLang, CONTACTS } from "../i18n";
import { scrollToId } from "../lib/scroll";

export const MobileCta = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-white/10 bg-black/90 backdrop-blur-lg md:hidden"
    >
      <a
        data-testid="mobile-cta-call"
        href={CONTACTS.phoneHref}
        className="flex flex-col items-center gap-1 py-3 text-[10px] font-bold uppercase tracking-widest text-neutral-300"
      >
        <Phone size={18} className="text-[#FF5A00]" />
        {t.mobile.call}
      </a>
      <a
        data-testid="mobile-cta-whatsapp"
        href={CONTACTS.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="flex flex-col items-center gap-1 border-x border-white/10 py-3 text-[10px] font-bold uppercase tracking-widest text-neutral-300"
      >
        <MessageCircle size={18} className="text-[#FF5A00]" />
        {t.mobile.whatsapp}
      </a>
      <button
        data-testid="mobile-cta-quote"
        onClick={() => scrollToId("#contacts")}
        className="flex flex-col items-center gap-1 bg-[#FF5A00] py-3 text-[10px] font-bold uppercase tracking-widest text-white"
      >
        <FileText size={18} />
        {t.mobile.quote}
      </button>
    </div>
  );
};
